import type {IAugmentedJQuery, IDirective, IScope} from 'angular';

/**
 * @ngdoc directive
 * @name kpPreventFocus
 * @module portaro.directives
 *
 * @description
 * Directive prevent focus. Currently works only on checkbox, not on labels, divs, etc.
 *
 * @example
 * ```
 * <example module="kpPreventFocusExample" name="kpPreventFocusExample" frame-no-resize="true">
 *  <file name="index.html">
 *      <input type="checkbox" kp-prevent-focus />
 *  </file>
 *  <file name="script.js">
 *      angular.module('kpPreventFocusExample', ['portaro.directives']);
 *  </file>
 * </example>
 * ```
 */
export default class PreventFocusDirective implements IDirective {
    public static directiveName = 'kpPreventFocus';

    public restrict = 'A';

    public link($scope: IScope, $element: IAugmentedJQuery) {
        $element.on('mousedown', (event) => event.preventDefault());
    }
}
